export default "__VITE_ASSET__h$2dTtoF__"